import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Navbar, Container, Button } from "react-bootstrap";
import { Outlet } from "react-router-dom";
import { useModuleContext } from "../Context/ModuleContext";
import NoteEditor from "../Components/NoteEditor/NoteEditor";
import "./RootLayout.css";
import { FaBookOpen } from "react-icons/fa";
import { FaEyeSlash } from "react-icons/fa6";

const LessonLayout = () => {
  const navigate = useNavigate();
  const { id, moduleId, lessonId } = useParams();
  const { module } = useModuleContext();
  const [selectedLesson, setSelectedLesson] = useState(lessonId);
  const [sectionName, setSectionName] = useState("");
  const [lessonName, setLessonName] = useState("");
  const [showNoteEditor, setShowNoteEditor] = useState(false);
  const [showNotebookButton, setShowNotebookButton] = useState(false);

  useEffect(() => {
    console.log("REACHED");
    setSelectedLesson(lessonId);
    const { sectionIndex, lessonIndex } = findCurrentLessonIndex();
    if (sectionIndex !== -1 && lessonIndex !== -1) {
      setSectionName(module.sections[sectionIndex].title);
      setLessonName(module.sections[sectionIndex].lessons[lessonIndex].title);
    }
    if (lessonId) {
      setShowNotebookButton(true);
    } else {
      setShowNotebookButton(false);
    }
  }, [lessonId, module]);

  const findCurrentLessonIndex = () => {
    if (!module) return { sectionIndex: -1, lessonIndex: -1 };
    for (let i = 0; i < module.sections.length; i++) {
      const section = module.sections[i];
      const lessonIndex = section.lessons.findIndex(
        (lesson) => lesson.id === selectedLesson
      );
      if (lessonIndex !== -1) {
        return { sectionIndex: i, lessonIndex };
      }
    }
    return { sectionIndex: -1, lessonIndex: -1 };
  };

  const handleNextActivity = () => {
    const { sectionIndex, lessonIndex } = findCurrentLessonIndex();
    if (sectionIndex === -1 || lessonIndex === -1) return;

    const currentSection = module.sections[sectionIndex];
    if (lessonIndex < currentSection.lessons.length - 1) {
      // Move to the next lesson in the same section
      const nextLesson = currentSection.lessons[lessonIndex + 1];
      navigate(`/programs/${id}/module/${moduleId}/${nextLesson.id}`);
      setSelectedLesson(nextLesson.id);
    } else if (sectionIndex < module.sections.length - 1) {
      // Move to the first lesson of the next section
      const nextSection = module.sections[sectionIndex + 1];
      if (nextSection.lessons.length > 0) {
        const nextLesson = nextSection.lessons[0];
        navigate(`/programs/${id}/module/${moduleId}/${nextLesson.id}`);
        setSelectedLesson(nextLesson.id);
      }
    }
  };

  const handlePreviousActivity = () => {
    const { sectionIndex, lessonIndex } = findCurrentLessonIndex();
    if (sectionIndex === -1 || lessonIndex === -1) return;

    const currentSection = module.sections[sectionIndex];
    if (lessonIndex > 0) {
      // Move to the previous lesson in the same section
      const previousLesson = currentSection.lessons[lessonIndex - 1];
      navigate(`/programs/${id}/module/${moduleId}/${previousLesson.id}`);
      setSelectedLesson(previousLesson.id);
    } else if (sectionIndex > 0) {
      // Move to the last lesson of the previous section
      const previousSection = module.sections[sectionIndex - 1];
      if (previousSection.lessons.length > 0) {
        const previousLesson =
          previousSection.lessons[previousSection.lessons.length - 1];
        navigate(`/programs/${id}/module/${moduleId}/${previousLesson.id}`);
        setSelectedLesson(previousLesson.id);
      }
    }
  };

  const handleNotebookClick = () => {
    if (lessonId) {
      setShowNoteEditor((prev) => !prev);
    }
  };

  return (
    <div className="d-flex flex-column vh-100 root-layout">
      <Navbar expand="lg" className="bg-white bg-gradient shadow-sm mb-2 py-1">
        <Container fluid className="justify-content-between">
          {showNotebookButton === true && (
            <Button
              variant="outline-primary"
              onClick={handleNotebookClick}
              className="me-auto"
            >
              {showNoteEditor ? "Fermer Cahier de note" : "Cahier de note"}
            </Button>
          )}

          <div className="text-center flex-grow-1">
            <span>
              {sectionName} / <FaBookOpen className="m-2" /> {lessonName}
            </span>
          </div>
          <div className="d-flex">
            <Button
              variant="secondary"
              onClick={handlePreviousActivity}
              className="me-2"
            >
              Précédent
            </Button>
            <Button variant="primary" onClick={handleNextActivity}>
              Suivant
            </Button>
          </div>
        </Container>
      </Navbar>
      <div className="content">
        <div className={`main-content ${showNoteEditor ? "with-editor" : ""}`}>
          <Outlet />
        </div>
        {showNoteEditor && lessonId && (
          <div className="note-editor-container">
            <FaEyeSlash
              className="eye-slash-icon"
              onClick={() => setShowNoteEditor(false)}
            />
            <NoteEditor key={lessonId} lessonId={lessonId} />
          </div>
        )}
      </div>
    </div>
  );
};

export default LessonLayout;
